const home = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="26"
      height="26"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M10.6446 18.1161H6.05016C5.9539 18.1161 5.87514 18.0373 5.87514 17.9411V8.27958C5.87514 8.18331 5.9539 8.10455 6.05016 8.10455H13.0775C13.1738 8.10455 13.2525 8.18331 13.2525 8.27958V11.9552L14.1277 11.1588V7.57947C14.1277 7.38694 13.9702 7.22941 13.7776 7.22941H12.6049V6.41553C12.6049 6.15299 12.4387 5.91671 12.1849 5.83794L9.75199 5.03282C9.62947 4.98906 9.4982 4.98906 9.37568 5.03282L6.9428 5.83794C6.68902 5.91671 6.52274 6.15299 6.52274 6.41553V7.22941H5.35006C5.15753 7.22941 5 7.38694 5 7.57947V18.6499C5 18.8425 5.15753 19 5.35006 19H10.6446V18.1161ZM7.39787 6.60806L9.55946 5.89045L11.7211 6.60806V7.23816H7.38913V6.60806H7.39787ZM18.7836 15.0181L14.8192 11.3951C14.7317 11.3163 14.5917 11.3163 14.5042 11.3951L10.5398 15.0181C10.4961 15.0619 10.4698 15.1144 10.4611 15.1844C10.4611 15.2457 10.4786 15.3069 10.5223 15.3507L10.7148 15.5607C10.7586 15.6045 10.8111 15.6307 10.8636 15.6307C10.9336 15.6482 11.0036 15.6132 11.0474 15.5695L11.2137 15.4207V18.7462C11.2137 18.8775 11.3187 18.9825 11.45 18.9825H13.9704C14.1016 18.9825 14.2066 18.8775 14.2066 18.7462V16.5059C14.2066 16.2521 14.4167 16.042 14.6705 16.042C14.9243 16.042 15.1343 16.2521 15.1343 16.5059V18.7462C15.1343 18.8775 15.2393 18.9825 15.3706 18.9825H17.891C18.0222 18.9825 18.1273 18.8775 18.1273 18.7462V15.4207L18.2935 15.5695C18.2935 15.5695 18.3898 15.6307 18.4598 15.6307C18.5211 15.6307 18.5823 15.5957 18.6173 15.552L18.8099 15.3419C18.8974 15.2457 18.8886 15.0969 18.7924 15.0094L18.7836 15.0181ZM17.3571 18.2299H15.8694V16.4971C15.8694 15.832 15.3268 15.2894 14.6617 15.2894C13.9966 15.2894 13.4453 15.832 13.4453 16.5059V18.2299H11.9488V14.7293L14.653 12.2527L17.3571 14.7293V18.2299ZM6.76763 8.89218H8.92921C9.02587 8.89218 9.10424 8.97054 9.10424 9.06721V9.59229C9.10424 9.68895 9.02587 9.76732 8.92921 9.76732H6.76763C6.67096 9.76732 6.5926 9.68895 6.5926 9.59229V9.06721C6.5926 8.97054 6.67096 8.89218 6.76763 8.89218ZM8.92921 10.4499H6.76763C6.67096 10.4499 6.5926 10.5283 6.5926 10.625V11.1501C6.5926 11.2467 6.67096 11.3251 6.76763 11.3251H8.92921C9.02587 11.3251 9.10424 11.2467 9.10424 11.1501V10.625C9.10424 10.5283 9.02587 10.4499 8.92921 10.4499ZM6.76763 12.0077H8.92921C9.02587 12.0077 9.10424 12.0861 9.10424 12.1827V12.7078C9.10424 12.8045 9.02587 12.8829 8.92921 12.8829H6.76763C6.67096 12.8829 6.5926 12.8045 6.5926 12.7078V12.1827C6.5926 12.0861 6.67096 12.0077 6.76763 12.0077ZM12.325 8.89218H10.3122C10.2155 8.89218 10.1372 8.97054 10.1372 9.06721V9.59229C10.1372 9.68895 10.2155 9.76732 10.3122 9.76732H12.325C12.4217 9.76732 12.5 9.68895 12.5 9.59229V9.06721C12.5 8.97054 12.4217 8.89218 12.325 8.89218ZM10.3122 10.4499H12.325C12.4217 10.4499 12.5 10.5283 12.5 10.625V11.1501C12.5 11.2467 12.4217 11.3251 12.325 11.3251H10.3122C10.2155 11.3251 10.1372 11.2467 10.1372 11.1501V10.625C10.1372 10.5283 10.2155 10.4499 10.3122 10.4499ZM12.325 12.0077H10.3122C10.2155 12.0077 10.1372 12.0861 10.1372 12.1827V12.7078C10.1372 12.8045 10.2155 12.8829 10.3122 12.8829H12.325C12.4217 12.8829 12.5 12.8045 12.5 12.7078V12.1827C12.5 12.0861 12.4217 12.0077 12.325 12.0077ZM6.76763 13.5655H8.92046C9.01713 13.5655 9.09549 13.6439 9.09549 13.7405V14.2656C9.09549 14.3623 9.01713 14.4406 8.92046 14.4406H6.76763C6.67096 14.4406 6.5926 14.3623 6.5926 14.2656V13.7405C6.5926 13.6439 6.67096 13.5655 6.76763 13.5655ZM8.92046 15.123H6.76763C6.67096 15.123 6.5926 15.2014 6.5926 15.2981V15.8232C6.5926 15.9198 6.67096 15.9982 6.76763 15.9982H8.92046C9.01713 15.9982 9.09549 15.9198 9.09549 15.8232V15.2981C9.09549 15.2014 9.01713 15.123 8.92046 15.123ZM6.76763 16.6808H8.92046C9.01713 16.6808 9.09549 16.7592 9.09549 16.8558V17.3809C9.09549 17.4776 9.01713 17.5559 8.92046 17.5559H6.76763C6.67096 17.5559 6.5926 17.4776 6.5926 17.3809V16.8558C6.5926 16.7592 6.67096 16.6808 6.76763 16.6808Z"
        fill="#56585D"
      />
    </svg>
  );
};
const details = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <g>
        <path
          d="M8 0C3.57803 0 0 3.57834 0 8C0 12.422 3.57834 16 8 16C12.422 16 16 12.4217 16 8C16 3.57803 12.4216 0 8 0ZM8 14.75C4.26897 14.75 1.25 11.7308 1.25 8C1.25 4.26897 4.26922 1.25 8 1.25C11.731 1.25 14.75 4.26922 14.75 8C14.75 11.731 11.7308 14.75 8 14.75Z"
          fill="#1EA6C6"
        />
        <path
          d="M8 6.69781C7.65481 6.69781 7.375 6.97763 7.375 7.32281V11.3476C7.375 11.6928 7.65481 11.9726 8 11.9726C8.34519 11.9726 8.625 11.6928 8.625 11.3476V7.32281C8.625 6.97763 8.34519 6.69781 8 6.69781Z"
          fill="#1EA6C6"
        />
        <path
          d="M8 5.9325C8.46599 5.9325 8.84375 5.55474 8.84375 5.08875C8.84375 4.62275 8.46599 4.245 8 4.245C7.53401 4.245 7.15625 4.62275 7.15625 5.08875C7.15625 5.55474 7.53401 5.9325 8 5.9325Z"
          fill="#1EA6C6"
        />
      </g>
      <defs>
        <clipPath id="clip0_329_4080">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
const reload = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
    >
      <g>
        <path
          d="M12 6C12 9.31648 9.31603 12 6 12C2.68352 12 0 9.31603 0 6C0 4.66116 0.435844 3.38946 1.23991 2.34633H0.46875C0.209859 2.34633 0 2.13647 0 1.87758C0 1.61869 0.209859 1.40883 0.46875 1.40883H2.31251C2.5714 1.40883 2.78126 1.61869 2.78126 1.87758V3.72134C2.78126 3.98023 2.5714 4.19009 2.31251 4.19009C2.05362 4.19009 1.84376 3.98023 1.84376 3.72134V3.1076C1.25482 3.95006 0.9375 4.95061 0.9375 6C0.9375 8.79827 3.2021 11.0625 6 11.0625C8.79827 11.0625 11.0625 8.7979 11.0625 6C11.0625 3.20173 8.7979 0.9375 6 0.9375C5.74111 0.9375 5.53125 0.727641 5.53125 0.46875C5.53125 0.209859 5.74111 0 6 0C9.31648 0 12 2.68397 12 6ZM6 6.46875H8.76562C9.02452 6.46875 9.23438 6.25889 9.23438 6C9.23438 5.74111 9.02452 5.53125 8.76562 5.53125H6.46875V2.31251C6.46875 2.05362 6.25889 1.84376 6 1.84376C5.74111 1.84376 5.53125 2.05362 5.53125 2.31251V6C5.53125 6.25889 5.74111 6.46875 6 6.46875Z"
          fill="#919499"
        />
      </g>
      <defs>
        <clipPath id="clip0_329_4078">
          <rect width="12" height="12" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
const cloud = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M13.3085 6.59119C13.3089 6.5686 13.3094 6.54605 13.3094 6.52338C13.3094 4.36397 11.5588 2.6134 9.3994 2.6134C7.53848 2.6134 5.98139 3.91347 5.58638 5.6549C5.21807 5.44871 4.7938 5.33064 4.34168 5.33064C2.93094 5.33064 1.78734 6.47428 1.78734 7.88498C1.78734 7.94264 1.78994 7.99964 1.7937 8.05637C0.746385 8.44514 0 9.4532 0 10.6358C0 12.1551 1.2316 13.3867 2.75084 13.3867H12.5614C14.4605 13.3867 16 11.8472 16 9.9481C16 8.3056 14.8483 6.93234 13.3085 6.59119Z"
        fill="#1EA6C6"
      />
    </svg>
  );
};
const close = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M13.1037 11.997L18.7737 6.32471C18.8462 6.25235 18.9037 6.16639 18.9429 6.07176C18.9822 5.97713 19.0024 5.87568 19.0024 5.77324C19.0024 5.67079 18.9822 5.56934 18.9429 5.47472C18.9037 5.38009 18.8462 5.29413 18.7737 5.22176C18.6254 5.07946 18.4279 5 18.2224 5C18.017 5 17.8194 5.07946 17.6712 5.22176L12.0012 10.9028L6.33118 5.22176C6.18292 5.07946 5.9854 5 5.77993 5C5.57446 5 5.37695 5.07946 5.22868 5.22176C5.15619 5.29413 5.09868 5.38009 5.05944 5.47472C5.0202 5.56934 5 5.67079 5 5.77324C5 5.87568 5.0202 5.97713 5.05944 6.07176C5.09868 6.16639 5.15619 6.25235 5.22868 6.32471L10.8987 11.997L5.22868 17.678C5.15646 17.7497 5.09913 17.8349 5.06001 17.9288C5.02088 18.0227 5.00074 18.1234 5.00074 18.2251C5.00074 18.3269 5.02088 18.4276 5.06001 18.5215C5.09913 18.6154 5.15646 18.7006 5.22868 18.7722C5.2999 18.8462 5.38564 18.9046 5.48051 18.9437C5.57538 18.9829 5.67732 19.002 5.77993 18.9998C5.88226 19 5.98361 18.98 6.0782 18.9409C6.17278 18.9019 6.25875 18.8445 6.33118 18.7722L12.0012 13.0999L17.6712 18.7722C17.7436 18.8445 17.8296 18.9019 17.9242 18.9409C18.0188 18.98 18.1201 19 18.2224 18.9998C18.325 19.002 18.427 18.9829 18.5219 18.9437C18.6167 18.9046 18.7025 18.8462 18.7737 18.7722C18.8459 18.7006 18.9032 18.6154 18.9424 18.5215C18.9815 18.4276 19.0016 18.3269 19.0016 18.2251C19.0016 18.1234 18.9815 18.0227 18.9424 17.9288C18.9032 17.8349 18.8459 17.7497 18.7737 17.678L13.1037 11.997Z"
        fill="#56585D"
      />
    </svg>
  );
};

const picture = {
  home,
  details,
  reload,
  cloud,
  close,
};

export default picture;
